import { render, staticRenderFns } from "./ProfileEdit.vue?vue&type=template&id=cb8f87e8&scoped=true&"
import script from "./ProfileEdit.js?vue&type=script&lang=js&"
export * from "./ProfileEdit.js?vue&type=script&lang=js&"
import style0 from "./ProfileEdit.scss?vue&type=style&index=0&id=cb8f87e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8f87e8",
  null
  
)

export default component.exports